"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { initInitData, Platform, retrieveLaunchParams } from "@telegram-apps/sdk";
import { ErrorBoundary } from "react-error-boundary";
import Tracker from "@openreplay/tracker";
import { useAuth } from "../Auth";
import Loading from "@/components/Loading";
export interface IMonitorProps {
  children: React.ReactNode;
}
export default function Monitor({
  children
}: IMonitorProps) {
  const {
    userId
  } = useAuth();
  const disableMonitor = process.env.NEXT_PUBLIC_DISABLE_MONITOR == "true";

  // Add Sentry
  useEffect(() => {
    if (disableMonitor) return;
    let teleId: string | undefined = undefined;
    let platform: Platform | undefined = undefined;
    try {
      const initData = initInitData();
      teleId = initData?.user?.id + "";
      const launchParams = retrieveLaunchParams();
      platform = launchParams.platform;
    } catch (e) {}
    if (!!!Sentry.getClient() && platform !== "web" && platform !== "weba") {
      let tracker: Tracker | null = null;
      if (!!process.env.NEXT_PUBLIC_OPENREPLAY_KEY) {
        tracker = new Tracker({
          projectKey: process.env.NEXT_PUBLIC_OPENREPLAY_KEY || "",
          ingestPoint: process.env.NEXT_PUBLIC_OPENREPLAY_INGEST_POINT || "",
          consoleMethods: ["log", "info", "warn", "error", "debug", "assert"],
          consoleThrottling: 30,
          captureExceptions: true,
          connAttemptCount: 3,
          autoResetOnWindowOpen: true,
          network: {
            capturePayload: true,
            sessionTokenHeader: false,
            failuresOnly: false,
            ignoreHeaders: [],
            captureInIframes: false
          }
        });
        tracker.setUserID(userId || teleId || "unknown-user");
        tracker.start().then(x => {
          if (!tracker) return;
          Sentry.setTag("openReplaySessionToken", tracker.getSessionToken());
          Sentry.setTag("openReplaySessionURL", tracker.getSessionURL());
        }).catch(e => {
          console.error("🚀 ~ tracker.start ~ e", e);
        });
      }
      Sentry.init({
        dsn: process.env.NEXT_PUBLIC_SENTRY_DSN || "",
        integrations: [Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false
        })],
        beforeSend(event) {
          if (event.extra) {
            console.log("🚀 ~ beforeSend ~ event.extra:", event.extra);
          } else {
            console.log("🚀 ~ beforeSend ~ event", event);
          }
          return event;
        },
        tracesSampleRate: 1,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        debug: process.env.NODE_ENV == "development",
        initialScope: {
          user: {
            id: userId || teleId || ""
          }
        },
        attachStacktrace: true
      });
    }
  }, []);
  function ErrorHandler({
    error
  }: {
    error: any;
  }) {
    console.log("🚀 ~ ErrorHandler ~ error: crash - app", error);
    if (disableMonitor) {
      return children;
    }
    return <Loading className="relative z-[9999]" data-sentry-element="Loading" data-sentry-component="ErrorHandler" data-sentry-source-file="index.tsx" />;
  }
  return <ErrorBoundary FallbackComponent={ErrorHandler} data-sentry-element="ErrorBoundary" data-sentry-component="Monitor" data-sentry-source-file="index.tsx">{children}</ErrorBoundary>;
}